/**
 * @Author: v_bwengguo
 * @Date: 2026-02-04 17:05:49
 * @Explain: 用户旅程
 */
import type { Node } from '@xyflow/react';
import type { SwitchValue } from 'tdesign-react';

export type UserJourneyModelStateType = {
  isShowDescriptionToJourney: SwitchValue;
  isShowDescriptionToTester: SwitchValue;
  isGetDetails: boolean;
  dispatchNodes: Node[];
  testLink: string;
  currentNodeId: string;
};
export type UserJourneyModelType = {
  namespace: string;
  state: UserJourneyModelStateType;
  reducers: {
    setIsShowDescription: (
      state: UserJourneyModelStateType,
      action: {
        payload: {
          isShowDescription: boolean;
          isTester: boolean;
        };
      },
    ) => UserJourneyModelStateType;
    setIsGetDetails: (
      state: UserJourneyModelStateType,
      action: { payload: boolean },
    ) => UserJourneyModelStateType;
    setDispatchNodes: (
      state: UserJourneyModelStateType,
      action: { payload: Node[] },
    ) => UserJourneyModelStateType;
    setTestLink: (
      state: UserJourneyModelStateType,
      action: { payload: string },
    ) => UserJourneyModelStateType;
    setCurrentNodeId: (
      state: UserJourneyModelStateType,
      action: { payload: string },
    ) => UserJourneyModelStateType;
  };
};
const UserJourneyModel: UserJourneyModelType = {
  namespace: 'UserJourneyModel',
  state: {
    // 是否显示描述文案 默认不展示 - 普通旅程
    isShowDescriptionToJourney: false,
    // 是否显示描述文案 默认不展示 - 测试玩家
    isShowDescriptionToTester: true,
    // 是否重新拉去详情请求
    isGetDetails: false,
    dispatchNodes: [],
    // 测试链接
    testLink: '',
    // 当前选中节点ID
    currentNodeId: '',
  },
  reducers: {
    // 是否展示描述文案
    setIsShowDescription(state, action) {
      if (action.payload.isTester) {
        return {
          ...state,
          isShowDescriptionToTester: action.payload.isShowDescription,
        };
      }
      return {
        ...state,
        isShowDescriptionToJourney: action.payload.isShowDescription,
      };
    },
    // 是否展示描述文案
    setIsGetDetails(state, action) {
      return {
        ...state,
        isGetDetails: action.payload,
      };
    },
    // 是否展示描述文案
    setDispatchNodes(state, action) {
      return {
        ...state,
        dispatchNodes: action.payload,
      };
    },
    // 设置测试链接
    setTestLink(state, action) {
      return {
        ...state,
        testLink: action.payload,
      };
    },
    // 设置当前选中节点ID
    setCurrentNodeId(state, action) {
      return {
        ...state,
        currentNodeId: action.payload,
      };
    },
  },
};
export default UserJourneyModel;
